import Vue from 'vue'
import Router from 'vue-router'
import TestHome from '@/components/abdp.sdk.test'
import login from '@/components/login'
//import modifypassword from '@/components/modifypassword'
import FirstPage from '@/components/firstPage'
import CampusJob from '@/components/campusJob'


Vue.use(Router)

// 在这里设置根路由
let routesArray = []

// 在这里添加各个子系统，子模块的路由文件

// abdp.sdk test 相关的路由
routesArray.push(...TestHome)
// //登录相关路由
routesArray.push(...login)
// 首页路由
routesArray.push(...FirstPage)
routesArray.push(...CampusJob)
//修改密码相关路由
//routesArray.push(...modifypassword)



// 定义主路由对象
let MainRouter = new Router({
  routes: routesArray
})

export default MainRouter



// WEBPACK FOOTER //
// ./src/components/router/index.js